/**
 * 地图调度管理
 * 2018-1-24
 */
"use strict";
angular.module("mapSchedulingManageModule", []).
controller("mapSchedulingManageCtrl", ["$scope", 'trsHttpService', "$q", '$filter', 'planCommandMonitorService', 'modalDialog','$modal', function($scope, trsHttpService, $q, $filter, planCommandMonitorService, modalDialog,$modal) {
    initStatus();
    initData();
    /**
     * [initData description:初始化数据]            
     */
    function initData() {
        requestData();
    };
    /**
     * [initStatus description:初始化状态]
     */
    function initStatus() {
        $scope.data = {};
        $scope.status = {
            page: {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: '',
                PAGECOUNT: '',
                copyCurrPage: 1,
            }
        };
    };
    /* 
     * [requestData description:获取数据]
     */
    function requestData() {
        $scope.params = {
            "typeid": 'screen',
            "serviceid": 'mapSchedulingMgr',
            "modelid": 'search',
            "page_size": $scope.status.page.PAGESIZE,
            "page_no": $scope.status.page.copyCurrPage - 1,
            "id": ''
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "get").then(function(data) {
            $scope.data = data.MAPRESULT.content.CONTENT;
            $scope.status.page.PAGECOUNT = data.MAPRESULT.content.TOTALPAGES;
            $scope.status.page.ITEMCOUNT = data.MAPRESULT.content.TOTALELEMENTS;
        });
    }
    /**
     * [timeStamp:将日期字符串转化为标准格式]
     */
    $scope.timeStamp = function(info) {
        return $filter("date")(info.UPDATETIME, "yyyy-MM-dd HH:mm:ss").toString();
    };
    /**
     * [selectPageNum description] 选择每页显示的数据数量
     * @return {[type]} [description]
     */

    $scope.selectPageNum = function() {
        $scope.status.page.copyCurrPage = 1;
        // $scope.page.PAGESIZE = $scope.page.CURRPAGE - 1;
        // $scope.params.page_size = $scope.page.PAGESIZE;
        requestData();
    };
    /*
     *[pageChanged description:跳转页面]
     */
    $scope.pageChanged = function() {
        $scope.status.page.copyCurrPage = $scope.status.page.CURRPAGE;
        $scope.params.page_no = $scope.status.page.copyCurrPage;
        requestData();
    };
    /*
     *[jumpToPage description:跳转到指定页面]
     */
    $scope.jumpToPage = function() {
        if (!$scope.status.page.copyCurrPage) return;
        if ($scope.status.page.copyCurrPage > $scope.status.page.PAGECOUNT) {
            $scope.status.page.copyCurrPage = $scope.status.page.PAGECOUNT;
        }
        $scope.status.page.CURRPAGE = $scope.status.page.copyCurrPage;
        requestData();
    };
    /**
     * [deleteSelectList description:实现删除功能]
     * @return {[type]} [description]
     */
    $scope.deleteSelectList = function(item) {
        var delParams = {
            "typeid": 'screen',
            "serviceid": 'mapSchedulingMgr',
            "modelid": 'delete',
            "id": item.ID,
            "istemp": '0',
        };

        modalDialog.confirmModal("删除提示", "是否确认删除？",
            function() {
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), delParams, 'post').then(function(data) {
                    requestData();
                });
            })
    };
    /**
     * [share description] 打开分享弹窗
     * @param  {[type]} uurl [分享链接地址]
     * @param  {[type]} id   [场景ID]             
     */
    $scope.shareBef = function(id) {
        planCommandMonitorService.share(id, '10', "复制链接和密码");
    };
    /**
     * [scan description:用于打开查看链接]
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.scan = function(item) {
        window.open(item.URL);
    };
    /*
        添加编辑地图调度 
     */
    $scope.added = function(params) {
        if (angular.isUndefined(params)){
            params ={};
        }
        var modalInstance = $modal.open({
            templateUrl: "./planningResource/commandMonitor/mapScheduling/addEdit/addEdit_tpl.html",
            windowClass: 'mapSchedulingAddEdit',
            backdrop: false,
            controller: "mapSchedulingAddEditCtrl",
            resolve: {
                paramsObj: params
            }
        });
        modalInstance.result.then(function(result) {
            requestData();
        }, function() {
            requestData();
        });

    };
}]);